import { connect } from 'react-redux'

import { makeGetTabOrder } from '../../../selectors/order'

import { TabOrderDetailsViewModel } from '../../../viewmodels/TabOrderViewModel'

import OrderDetailsModal from '../../../components/tabs/OrderDetailsModal'

const mapStateToProps = (state, ownProps) => {
  const orderId = ownProps?.match?.params?.orderId ?? ''
  const getTabOrder = makeGetTabOrder()
  const tabOrder = getTabOrder(state, orderId)
  const order = TabOrderDetailsViewModel(tabOrder)

  return { orderId: order.orderId, orderState: order.orderState }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetailsModal)
